export enum PbhRequestStatus {
  // PRE-OPEN
  /// <summary>
  ///  Open statüsü öncesi. (Seçilen PN'nin Access veya Repair alanlarından biri: YES)
  /// </summary>
  Created = 10,

  /// <summary>
  ///  WAITING POOL SCOPE - STATUS 1
  ///  Pool scope: NO
  /// </summary>
  WaitingPoolScope = 20,

  /// <summary>
  ///  REJECTED DUE TO POOL SCOPE - STATUS 5
  ///  PBH ENG ekibi scope onayı: NO
  /// </summary>
  RejectedDueToPoolScope = 30,

  // OPEN
  /// <summary>
  ///  OPEN - STATUS 3 (MAJOR)
  ///  Pool scope: YES || PBH ENG scope onayı: YES
  /// </summary>
  Open = 100,

  /// <summary>
  ///
  ///  Rejected Önerisi
  /// </summary>
  RejectionProposal = 105,

  /// <summary>
  ///  REJECTED - STATUS 7
  ///  PBH ekibi talep onayı: NO
  /// </summary>
  Rejected = 110,

  // INPROGRESS
  /// <summary>
  ///  INPROGRESS - MAJOR
  /// </summary>
  Inprogress = 200,

  /// <summary>
  ///  UNSHIPPED SVC - STATUS 6
  ///  PBH ekibi talep onayı: YES
  /// </summary>
  UnshippedSvc = 210,

  /// <summary>
  ///  RESERVED - STATUS 8
  ///  Reserve işlemi yapıldı mı
  /// </summary>
  Reserved = 220,

  /// <summary>
  ///  Serviceable Shipped
  ///  Serviceable oluşturulduktan sonraki status
  /// </summary>
  ServiceableShipped = 225,

  /// <summary>
  ///  SHIPPING PROCESS - STATUS 9
  ///  XO oluşturuldu mu? Sevk formu pool tarafından onaylandı mı?: YES
  /// </summary>
  ShippingProcess = 230,

  /// <summary>
  ///  SVC REDELIVERY - STATUS 10
  ///  Müşteri serviceable komponenti kabul etti mi: NO
  /// </summary>
  SvcRedelivery = 240,

  /// <summary>
  ///  WAITING CORE INFO - STATUS 11
  ///  Müşteri unserviceable komponenti girdi mi: NO
  /// </summary>
  WaitingCoreInfo = 250,

  /// <summary>
  ///  CORE SHIPPING PROCESS - STATUS 12
  ///  Müşteri unserviceable komponenti girdi mi: YES
  /// </summary>
  CoreShippingProcess = 260,

  // ACCOMPLISHED
  /// <summary>
  ///  ACCOMPLISHED - STATUS 13 (MAJOR)
  ///  TT UNSVC kabul etti mi: YES
  /// </summary>
  ///
  Accomplished = 300,

  /// <summary>
  ///  CORE DISPUTE PROCESS (KARANTINA) - STATUS 14
  ///  TT UNSVC kabul etti mi: NO
  /// </summary>
  ///
  CoreDisputeProcess = 310,

  /// <summary>
  ///  ALTERNATE PN OFFERED - STATUS 15 (MAJOR)
  /// </summary>
  ///
  AlternatePnNone = 155,

  /// <summary>
  ///  ALTERNATE PN OFFERED - STATUS 15 (MAJOR)
  /// </summary>
  ///
  AlternatePnOffered = 150,

  /// <summary>
  ///  ALTERNATE PN ACCEPTED - STATUS 16
  ///  Müşteri kabul etti mi: YES
  /// </summary>
  ///
  AlternatePnAccepted = 160,

  /// <summary>
  ///  ALTERNATE PN REJECTED - STATUS 17
  ///  Müşteri kabul etti mi:
  /// </summary>
  ///
  AlternatePnRejected = 170,
  /// <summary>
  ///  WAITING RESPONSE FROM CUSTOMER - STATUS 17
  ///  Kayıt detayında WRFC tabında müşteriden cevap beklendiği durum.
  /// </summary>
  ///

  /// <summary>
  ///  Cancelled
  ///  Kayıdın kullanıcı tarafından Cancel edildiği durum.
  /// </summary>
  ///
  Cancelled = 410,

  /// <summary>
  ///  WaitingResponseFromCUstomer
  ///  Kayıt detayında waiting response from customer tabında müşteriden cevap beklendiği durum.
  /// </summary>
  WaitingResponseFromCustomer = 400,

  /// <summary>
  ///  SentEightWings
  ///  Kayıdın 8W tarafına gönderildigi durum.
  /// </summary>
  SentEightWings = 510,

  /// <summary>
  ///  ServiceableDelivered
  ///   Owner:AARFLYDB-O olan isteklerde serviceable sekmesinde POD tipinde bir doküman yüklendiği durum.
  /// </summary>
  ServiceableDelivered = 520,

  /// <summary>
  ///  LOCAL REPAIR
  ///  Müşteri tarafınca yerel tamir edilecek talep.
  ///  isLocalRepair = true ile PBH accept sonrası bu statüye geçer.
  /// </summary>
  LocalRepair = 530,

  /// <summary>
    ///     Contract Statusu CDM Pool tarafından "HOLD" durumuna gectiginde bu statuye gecer
    /// </summary>
  Suspended= 600,

  /// <summary>
  ///  Bir önceki Statu
  ///  Bu statu repositorye gönderilirse kayıdın bir önceki statüsüne geri döner
  /// </summary>
  PreviousStatus = 9999,
}

export const PbhRequestStatusListTab = isCustomer => {
  if (isCustomer) {
    return pbhRequestStatusTabList.filter(x => x.value !== PbhRequestStatus.Reserved);
  }
  return pbhRequestStatusTabList;
};

const pbhRequestStatusTabList = [
  { value: PbhRequestStatus.WaitingPoolScope, label: "Waiting Pool Scope" },
  { value: PbhRequestStatus.Open, label: "Open Requests" },
  { value: PbhRequestStatus.LocalRepair, label: "Local Repair" },
  { value: PbhRequestStatus.UnshippedSvc, label: "Unshipped Svc" },
  { value: PbhRequestStatus.Reserved, label: "PBH Reserved" },
  { value: PbhRequestStatus.ShippingProcess, label: "Shipping Process" },
  { value: PbhRequestStatus.RejectionProposal, label: "Serviceable Rejected List" },
  { value: PbhRequestStatus.Suspended, label: "Suspended Requests" },
];
